export function getParams(state) {
	return state.params
}


// WEBPACK FOOTER //
// ./src/modules/cashReceipts/getters.js